import BaseStore from '../BaseStore';
import ReportingTemplateModel from "../../models/SystemConfiguration/ReportingTemplateModel";
import { observable, toJS } from 'mobx';
import { downloadCSV, downloadPDF } from '../../components/DataDelivery/ReportingTemplate/downloader';

class ReportingTemplateStore extends BaseStore {

  reportingTemplateHeaderStore;

  formatOptions = [
    { label: 'CSV', value: 'csv' },
    { label: 'PDF', value: 'pdf' },
  ]

  orientationOptions = [
    { label: 'Landscape', value: 'landscape' },
    { label: 'Portrait', value: 'portrait' },
  ]

  aggregationMethodOptions = [
    { id: 1, name: "Min" },
    { id: 2, name: "Max" },
    { id: 3, name: "Avg" },
    { id: 4, name: "Sum" },
    { id: 5, name: "Instantaneous" },
    { id: 6, name: "Point Discharge" },
    { id: 7, name: "Mean Daily Discharge" },
  ]

  aggregationPeriodOptions = [
    { id: 1, name: 'Hourly' },
    { id: 2, name: 'Daily' },
    { id: 3, name: 'Monthly' },
    { id: 4, name: 'Annual' },
    { id: 5, name: 'Custom Hourly' },
    { id: 6, name: 'All' },
  ]

  aggregationTypeOptions = [
    { id: 1, name: 'Left Closed Right Open' },
    { id: 2, name: 'Left Open Right Closed' },
  ]

  sortOrder = [
    { label: 'Asc', value: 0 },
    { label: 'Desc', value: 1 },
  ]

  @observable columnTypes = [];

  constructor(transportLayer, reportingTemplateHeaderStore) {
    super(ReportingTemplateModel, transportLayer);
    this.reportingTemplateHeaderStore = reportingTemplateHeaderStore;
  }

  fetchColumnTypes() {
    this.transportLayer.columnTypes.fetchAll()
      .then(res => {
        this.columnTypes = res;
      })
  }

  downloadReport = async (data, format, info, filename) => {
    if (!this.reportingTemplateHeaderStore.isLoading && !this.reportingTemplateHeaderStore.items.length) await this.reportingTemplateHeaderStore.fetchItems();

    const headers = toJS(this.reportingTemplateHeaderStore.items);
    let header = null;
    if (!!info.header_id) {
      header = this.reportingTemplateHeaderStore.findById(info.header_id)
    } else {
      const defaultHeader = headers.find(item => !!item.default);
      header = !!defaultHeader && defaultHeader;
    }
    if (!header && !!headers.length) header = headers[0];

    switch (format.toLowerCase()) {
      case 'csv': return downloadCSV(data);
      case 'pdf': return downloadPDF(data, Object.assign({}, info, { title1: header.title1, title2: header.title2, logo: header.logo }), filename);
      default: return null;
    }
  }

}

export default ReportingTemplateStore;


// WEBPACK FOOTER //
// ./src/stores/SystemConfiguration/ReportingTemplateStore.js